export default __webpack_public_path__ + "static/media/link-white.5228d68c.5228d68c.svg";